import { PropsWithChildren } from 'react';
import { Text } from '~/components/typography';
import { StyledReviewBlock, ReviewBlockProps, ReviewItem } from './review-block.style';

const ReviewBlock = ({ children, ...props }: PropsWithChildren<ReviewBlockProps>) => (
  <StyledReviewBlock {...props}>{children}</StyledReviewBlock>
);

const Label = ({ children }: PropsWithChildren<{}>) => (
  <Text mb={2} tag="h2" textStyle="heading500">
    {children}
  </Text>
);

const Notice = ({ children }: PropsWithChildren<{}>) => (
  <Text mt={2} opacity="low" textStyle="paragraph400">
    {children}
  </Text>
);

export interface ItemProps {
  label?: string;
  notice?: string;
  notranslate?: boolean;
}

const Item = ({ children, label, notice, notranslate }: PropsWithChildren<ItemProps>) => (
  <ReviewItem>
    {label && <Label>{label}</Label>}
    <Text className={notranslate ? 'notranslate' : ''}>{children}</Text>
    {notice && <Notice>{notice}</Notice>}
  </ReviewItem>
);

ReviewBlock.Item = Item;
export { ReviewBlock };
